export default {
    listagem: {
        table: {
            empty: "No Triggers Found",
            nome: "Name",
            novo: "Create New Trigger",
            regra: "Rule",
            acoes: "Actions",
            editar: "Edit",
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Create New Trigger',
            editar: 'Edit Trigger'
        },
        fields: {
            nome: {
                label: "Name",
                description: "What will the name of the new Trigger be?"
            },
            condicao: {
                fields: {
                    firstField: {
                        label: "Field",
                        description: "What will be the field to validate."
                    },
                    rule: {
                        label: "Condition",
                        description: "What will be the condition."
                    },
                    secondField: {
                        label: "Amount",
                        description: "What will be the amount to compare."
                    },
                    thirdField: {
                        label: "Other Amount",
                        description: "What will be the other amount to compare."
                    }
                },
                DB_fields: {
                    exam_code: "Exam Code",
                    method_code: "Exam Method",
                    specimen_code: "Sample Code",
                    value_quantity_value: "Result Value",
                    reference_range_text: "Reference Range Text",
                    reference_range_structured: "Structured Reference Range",
                    parent_exam_code: "Parent Exam Code"
                },
                rules: {
                    isNull: "Is empty",
                    isNotNull: "It is not empty",
                    bigger: "Bigger then",
                    biggerOrEqual: "Greater than or equal to",
                    less: "Less than",
                    lessOrEqual: "Less than or equal to",
                    equal: "It's the same as",
                    different: "It is other than",
                    between: "Its between",
                    notBetween: "Is not between"
                }
            },
            action: {
                label: "Action",
                description: "What will be the action taken by the system?",
                options: {
                    Blocked: "Block Exam",
                    Alert: "Alert About Exam"
                }
            }
        },
        buttons: {
            adicionar_condicao: 'Add Condition',
            remover_condicao: 'Remove Condition',
            salvar: 'Save Trigger'
        },
        create: {
            success: "Trigger Successfully Created!",
            error: "Error Creating Trigger!"
        },
        update: {
            success: "Trigger Successfully Edited!",
            error: "Error Editing Trigger!"
        }
    }
}
